import React from "react";

/**
 * "Continuer avec Google" — Emergent-managed Google OAuth.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
 * Derive redirect from window.location.origin so it always matches the current environment
 * (preview, custom domain, etc.).
 */
export default function GoogleLoginButton({ label = "Continuer avec Google", className = "", testid = "google-login-btn" }) {
  const handleClick = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={testid}
      className={
        "w-full h-11 rounded-full inline-flex items-center justify-center gap-3 bg-white border border-slate-200 text-slate-700 font-medium text-sm hover:bg-slate-50 hover:border-slate-300 transition shadow-sm " +
        className
      }
      aria-label={label}
    >
      {/* Google "G" logo (official colors, inline SVG — no external request) */}
      <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"/>
        <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.836.86-3.048.86-2.344 0-4.328-1.583-5.036-3.71H.957v2.332A9 9 0 009 18z"/>
        <path fill="#FBBC05" d="M3.964 10.708A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.708V4.96H.957A9 9 0 000 9c0 1.452.348 2.827.957 4.04l3.007-2.332z"/>
        <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A9 9 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"/>
      </svg>
      <span>{label}</span>
    </button>
  );
}
